import { render, staticRenderFns } from "./TagModal.vue?vue&type=template&id=67498a3c&scoped=true&"
import script from "./TagModal.vue?vue&type=script&lang=ts&"
export * from "./TagModal.vue?vue&type=script&lang=ts&"
import style0 from "./TagModal.vue?vue&type=style&index=0&id=67498a3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67498a3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('67498a3c', component.options)
    } else {
      api.reload('67498a3c', component.options)
    }
    module.hot.accept("./TagModal.vue?vue&type=template&id=67498a3c&scoped=true&", function () {
      api.rerender('67498a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CortaCorriente/TagModal.vue"
export default component.exports